import { EvacZone, FormEvacZoneStatus } from 'shared/types';
import {
  EVAC_ZONE_STATUS_ENABLED,
  EvacZoneStyles,
} from '../../../../constants';
import { EvacZoneStatusChange } from '../../types';

export const updateEvacZoneStatuses = (
  changes: EvacZoneStatusChange[],
  currentEvacZoneStatuses: FormEvacZoneStatus[],
  evacZones: EvacZone[],
): { updatedStatuses: FormEvacZoneStatus[]; changeCount: number } => {
  const updatedEvacZones = [...currentEvacZoneStatuses];
  let changeCount = 0;

  changes.forEach(({ uid, status, acceptExternalStatus }) => {
    const existingZoneIndex = updatedEvacZones.findIndex(
      (s) => s.evacZone.uidV2 === uid,
    );

    const zone = evacZones.find((z) => z.uidV2 === uid);
    if (!zone) {
      return;
    }

    const newStatus =
      (acceptExternalStatus ? zone.externalStatus?.mapped : status) ||
      undefined;

    if (
      newStatus &&
      !EVAC_ZONE_STATUS_ENABLED[
        zone.region.evacZoneStyle || EvacZoneStyles.default
      ][newStatus]
    ) {
      // invalid status for the zone
      return;
    }

    // removing a status from a zone
    if (newStatus === undefined) {
      if (existingZoneIndex === -1) {
        return;
      }
      updatedEvacZones.splice(existingZoneIndex, 1);
      changeCount += 1;
      return;
    }

    // adding a status to a zone without a status
    if (existingZoneIndex === -1) {
      updatedEvacZones.push({
        evacZone: {
          ...zone,
          regionEvacZoneStyle: zone.region.evacZoneStyle,
          regionId: zone.region.id,
        },
        status: newStatus,
        prevStatus: zone.status,
      });
      changeCount += 1;
      return;
    }

    // updating an existing status on a zone
    if (updatedEvacZones[existingZoneIndex].status === newStatus) {
      return;
    }
    updatedEvacZones[existingZoneIndex].status = newStatus;
    updatedEvacZones[existingZoneIndex].prevStatus = zone.status;
    changeCount += 1;
  });

  return { updatedStatuses: updatedEvacZones, changeCount };
};
